var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 0H1.33333C0.596667 0 0 0.596667 0 1.33333V22.6667C0 23.4033 0.596667 24 1.33333 24H30.6667C31.4033 24 32 23.4033 32 22.6667V1.33333C32 0.596667 31.4033 0 30.6667 0ZM29.996 1.33333L16.4427 13.3807C16.1893 13.606 15.808 13.6047 15.5567 13.3813L2.00333 1.33333H29.996ZM1.33333 22.6667V2.522L14.6713 14.3787C15.05 14.7147 15.5247 14.8827 16 14.8827C16.4753 14.8827 16.95 14.7147 17.3287 14.378L30.6667 2.522V22.6667H1.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope_icon.70650245ed39dec828a36ab9ff5095ba.svg";
export { ForwardRef as ReactComponent };